import { InjectionToken } from "@angular/core";

export interface Language{
    label: string;
    lang: string;
    lcid: string;
    flag: string;
    currencyCode: string;
};

export const LANGUAGE = new InjectionToken<Language[]>('language');